/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryinfocreated3Inputs */

const en_medialibraryinfocreated3 = /** @type {(inputs: Medialibraryinfocreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_medialibraryinfocreated3 = /** @type {(inputs: Medialibraryinfocreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Medialibraryinfocreated3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryinfocreated3 = /** @type {((inputs?: Medialibraryinfocreated3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryinfocreated3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryinfocreated3(inputs)
	return de_medialibraryinfocreated3(inputs)
});
export { medialibraryinfocreated3 as "mediaLibraryInfoCreated" }